import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { TaxisUsuariosModel } from 'src/app/shared/models/taxis/taxis.model';

@Component({
  selector: 'app-add-usuario-taxis',
  templateUrl: './add-usuario-taxis.component.html',
  styleUrls: ['./add-usuario-taxis.component.css']
})
export class AddUsuarioTaxisComponent implements OnInit {

  @Input() taxisUsuariosCombo : TaxisUsuariosModel[];
  @Input("dNewUser") dNewUser : boolean;
  @Output()
  onClose : EventEmitter<string> = new EventEmitter();
  @ViewChild("newusu")
  iptNewUser : ElementRef;
  constructor(private msg : ToastService) {
   }

  ngOnInit(): void {

    setTimeout(() => {
      this.iptNewUser.nativeElement.focus();

    }, 500);
  }

  addUsuario() {
    var value = this.iptNewUser.nativeElement.value;
    if (!value || value.trim() == "") {
      this.msg.clear();
      this.msg.showWarn("Inserta un nombre, por favor.");
      return;
    }
    this.removeNewUsuario();
    this.closeAddUsuario(value);
  }

  closeAddUsuario(value?: string) {
    this.iptNewUser.nativeElement.value = "";
    this.dNewUser = false;
    this.onClose.emit(value);
  }

  removeNewUsuario() {
    var index = this.taxisUsuariosCombo.findIndex(x => x.id_usuario == 0);
    if (index != -1) {
      this.taxisUsuariosCombo.splice(index, 1);
    }
    console.log(this.taxisUsuariosCombo);
    
  }


}
